import { inject, ViewContainerRef } from '@angular/core';

import { map } from 'rxjs';

import { DialogService, DialogWidth } from '@recruitee/user-interface';

import type { ConfirmDialogResult } from './confirm-reveal-dialog/confirm-reveal-dialog.component';
import { ConfirmRevealDialogComponent } from './confirm-reveal-dialog/confirm-reveal-dialog.component';

export const revealConfirmationFactory = () => {
  const dialogService = inject(DialogService);
  const vcRef = inject(ViewContainerRef);

  return () =>
    dialogService
      .openCustom(
        ConfirmRevealDialogComponent,
        {
          width: DialogWidth.SmallXX,
        },
        null,
        vcRef,
      )
      .afterClosed.pipe(
        map((result: ConfirmDialogResult | undefined) => {
          if (result === undefined) {
            return { confirmed: false, dontAskAgain: false };
          }

          return result;
        }),
      );
};
